"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.conferencerProviderCallActions = exports.conferencerCalleeCallResponses = exports.conferencerAcknowledgementStatuses = exports.conferencerCallStatuses = void 0;
exports.conferencerCallStatuses = [
    'CANCELLED',
    'INITIATED',
    'UNANSWERED_CALLER',
    'UNANSWERED_CALLEE',
    'BUSY_CALLER',
    'BUSY_CALLEE',
    'REJECTED_BY_CALLER',
    'REJECTED_BY_CALLEE',
    'RINGING_CALLER',
    'RINGING_CALLEE',
    'RECORDING',
    'COMPLETED',
    'FAILED',
];
exports.conferencerAcknowledgementStatuses = ['PENDING', 'ACCEPTED', 'REJECTED', 'EXPIRED'];
exports.conferencerCalleeCallResponses = ['ACCEPTED', 'REJECTED'];
exports.conferencerProviderCallActions = [
    'SERVER_TIME_LIMIT_HIT',
    'PARTICIPANT_REMOVED',
    'RING_TIMEOUT_EXPIRED',
];
//# sourceMappingURL=Conferencer.js.map